import { FaCar } from 'react-icons/fa';

function Login({ handleLogin, email, setEmail, password, setPassword, error }) {
  return (
    <div className="login-container">
      <div className="login-box">
        <FaCar size={50} style={{ marginBottom: '20px' }} />
        <h1>Admin Console</h1>
        <p>Please sign in to continue</p>
        <form onSubmit={handleLogin} className="login-form">
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Email"
            required
          />
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Password"
            required
          />
          <button type="submit" className="btn btn-primary">Login</button>
          {error && <p className="error-text" style={{padding: '20px 0 0 0'}}>{error}</p>}
        </form>
      </div>
    </div>
  );
}

export default Login;
